export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if(!this.licenseDetails) {
            this.$state.go('company');
        }
    }

    isLicensed() {
        return this.licenseDetails.licenseInfo.licenseStatus == 'LICENSED';
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.controller.js